<!-- 默认布局 -->
<template>
  <div class="layout-default-wrapper">
    <!-- 公共头部 -->
    <div class="layout-header">
      <div class="container">
        <router-link class="logo" to="/">
          <img class="img" :src="logUrl" alt="logo" />
        </router-link>
        <div class="menu-list">
          <router-link
            class="menu-item"
            :class="{ active: item.routerTag === ativeRouterTag }"
            v-for="item in menuList"
            :key="item.name"
            :to="item.link"
            >{{ item.name }}</router-link
          >
        </div>
        <router-link v-if="ifShowDown" class="common-button btn-download" to="/download">下 载</router-link>
      </div>
    </div>
    <!-- 内容区域 -->
    <router-view></router-view>
    <!-- 公共底部 -->
    <div class="layout-footer">
      <div class="container">
        <div class="footer-links">
          <dl class="link-group" v-for="firItem in footerLinkList" :key="firItem.title">
            <dt class="group-title">{{ firItem.title }}</dt>
            <dd class="link-dd" v-for="item in firItem.subList" :key="item.linkText">
              <img class="link-icon" v-if="item.icon" :src="item.icon" />
              <p class="link-label" v-if="item.linkType === 'nolink'">{{ item.linkText }}</p>
              <a class="link-href" v-else-if="item.linkType === 'inner'" :href="item.link">{{ item.linkText }}</a>
              <a class="link-href" v-else-if="item.linkType === 'outer'" :href="item.link" target="_bank">{{ item.linkText }}</a>
              <span class="link-href" v-else-if="item.linkType === 'request'" @click="requestDownload(item)">{{ item.linkText }}</span>
            </dd>
          </dl>
        </div>
        <div class="footer-copyright">
          <p class="copyright">
            © 2025 标签智印软件 保留所有权利
            <a class="copy-link" href="https://beian.miit.gov.cn" target="_blank">粤ICP备2025393166号-1</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlatformList } from '@/plugins/api.js';
import { partnerCode } from '@/plugins/const.js';
import { openNewPage } from '@/plugins/util.js';

export default {
  name: 'App',
  data() {
    return {
      logUrl: 'https://static.yunlabel.com/assets/images/home/logo-text.png',
      // 顶部导航菜单数组，routerTag用于标识菜单归类，配合ativeRouterTag来选中当前菜单
      menuList: [
        { name: '首页', link: '/', routerTag: 'home' },
        { name: '服务支持', link: '/service', routerTag: 'service' },
        { name: '关于我们', link: '/about', routerTag: 'about' },
      ],
      footerLinkList: [
        {
          title: '标签智印软件',
          subList: [{ linkText: '专业标签设计与打印解决方案，让标签制作变得简单高效。为企业提供一站式标签管理系统。', linkType: 'nolink' }],
        },
        {
          title: '产品',
          subList: [
            { linkText: 'Windows端', linkType: 'request', equip: 3, requesting: false },
            { linkText: 'Android端', linkType: 'request', equip: 1, requesting: false },
            { linkText: 'IOS端', linkType: 'request', equip: 2, requesting: false },
            { linkText: 'Harmony端', linkType: 'request', equip: 7, requesting: false },
            { linkText: '麒麟系统端', linkType: 'outer', link: 'https://static.yunlabel.com/kylin/labelmate-v1.0.100.deb' },
          ],
        },
        {
          title: '公司',
          subList: [
            { linkText: '关于我们', link: '/about', linkType: 'inner' },
            { linkText: '服务协议', link: 'https://protocol.yunlabel.com/protocol/pc_service.html', linkType: 'outer' },
            { linkText: '隐私协议', link: 'https://protocol.yunlabel.com/protocol/pc_privacy.html', linkType: 'outer' },
          ],
        },
        {
          title: '联系我们',
          subList: [
            { linkText: 'xingtuzhiyun@163.com', icon: 'https://static.yunlabel.com/assets/images/footer/icon-email.png', linkType: 'nolink' },
            { linkText: '深圳市南山区粤海街道科技园社区', icon: 'https://static.yunlabel.com/assets/images/footer/icon-map.png', linkType: 'nolink' },
          ],
        },
      ],
    };
  },
  computed: {
    // 在这里处理顶部导航的选中
    ativeRouterTag() {
      const meta = this.$route.meta || {};
      const menuType = meta.menu || '';
      const findMenu = this.menuList.find((item) => menuType === item.routerTag);
      return findMenu ? findMenu.routerTag : '';
    },
    // 下载页不要显示路由
    ifShowDown() {
      return !this.$route.path.startsWith('/download');
    },
  },
  methods: {
    // 点击下载
    requestDownload(linkItem) {
      const storageDownList = window.sessionStorage.getItem('downList');
      // 先找缓存
      if (storageDownList) {
        const arrList = JSON.parse(storageDownList);
        const findItem = arrList.find((item) => item.equip === linkItem.equip);
        if (findItem && findItem.filePath) {
          openNewPage({ url: findItem.filePath, ifBank: true });
        } else {
          this.getDownloadUrl(linkItem);
        }
      } else {
        // 找不到就从接口拿
        this.getDownloadUrl(linkItem);
      }
    },
    // 从接口获取下载地址
    async getDownloadUrl(linkItem) {
      linkItem.requesting = true;
      const res = await getPlatformList({ code: partnerCode }).catch((err) => err);
      linkItem.requesting = false;
      // 没数据就直接跳下载页
      if (res.code !== 100 || !Array.isArray(res.data) || res.data.length === 0) {
        this.$router.push('/download');
        return;
      }
      // 有数据就从里面获取
      let filePath = '';
      const storageDownList = res.data.map((item) => {
        if (item.equip === linkItem.equip) {
          filePath = item.filePath;
        }
        return { equip: item.equip, filePath: item.filePath };
      });
      // 再次缓存
      window.sessionStorage.setItem('downList', JSON.stringify(storageDownList));
      if (filePath) {
        openNewPage({ url: filePath, ifBank: true });
      } else {
        this.$router.push('/download');
      }
    },
  },
};
</script>

<style lang="less">
html {
  font-family: 'Microsoft YaHei', 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

body {
  font-size: 16px;
}

a {
  text-decoration: none;
  outline: none;
  color: #333;
}
img {
  display: block;
  border: none;
}
ul,
li,
ol {
  list-style: none;
}
i {
  font-style: normal;
}
.layout-default-wrapper {
  min-width: 1440px;
}
.container {
  width: 1440px;
  margin: 0 auto;
}

.layout-header {
  background-color: #fff;
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 110px;
  }
  .logo .img {
    height: 36px;
  }
  .menu-list {
    display: flex;
    align-items: center;
    flex: 1;
    padding-left: 200px;
    text-align: left;
  }
  .menu-item {
    margin: 0 20px;
    padding: 0 20px;
    font-size: 18px;
    color: #000;
    line-height: 60px;
    transition: font-weight 0.2s;
    &:hover,
    &.active {
      font-weight: 800;
    }
  }
  .btn-download {
    width: 110px;
    min-width: auto;
    height: 42px;
    font-size: 16px;
  }
}

.layout-footer {
  background-color: #f9f9f9;
  .footer-links {
    display: flex;
    padding: 70px 0 20px;
  }
  .link-group {
    flex: 1;
    padding-left: 120px;
    overflow: hidden;
    &:first-child {
      padding-left: 0;
    }
  }
  .group-title {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 1.5;
    color: #010101;
    font-weight: 600;
  }
  .link-dd {
    margin-bottom: 15px;
  }
  .link-href,
  .link-label {
    font-size: 15px;
    line-height: 1.7;
    color: #010101;
    font-weight: 500;
    transition: opacity 0.25s;
  }
  .link-href {
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
  }
  .link-dd {
    display: flex;
    align-items: center;
  }
  .link-icon {
    width: 19px;
    margin-right: 5px;
    margin-bottom: -1px;
  }

  .footer-copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 128px;
  }
  .copyright {
    font-weight: 400;
    font-size: 16px;
    color: #010101;
    line-height: 1.7;
  }
  .copy-link {
    color: #010101;
    &:hover {
      opacity: 0.7;
    }
  }
}

.common-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 0 20px 1px;
  min-width: 140px;
  font-size: 18px;
  color: #fff;
  border-radius: 16px;
  background: radial-gradient(0% 0% at 0% 0%, #fc5b41 0%, #fe6a40 100%), #fd593f;
  cursor: pointer;
  &:hover {
    background: radial-gradient(0% 0% at 0% 0%, #fc5238 0%, #fa5527 100%), #ff4428;
  }
}

.ellips {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.ellips2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
